export const API_PATH_apiUserMngmtUserUndelete = '/services/users-management/user/undelete';
